// Fill states select on homepage
(function (Drupal, once) {
  Drupal.behaviors.replocator = {
  
  attach: function(context, settings) {
    once('replocator-init', '#locator-search', context).forEach(() => {
    if (typeof repLocator === 'undefined') {
      console.warn('Can not load the library repLocator');
      return;
    }

    if (!settings.replocator) {
      console.warn('Can not found the replocator JS');
      return ;
    }

    const usStates = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY', 'AE', 'AP', 'AA'];

    const caStates = [ "CAN-ALB", "CAN-BCO", "CAN-MAN", "CAN-NBR", "CAN-LAB", "CAN-NWT", "CAN-NSC", "CAN-NUN", "CAN-ONT", "CAN-PRI", "CAN-QUE", "CAN-SAS","CAN-YUK" ];


    function autoSelectCountry() {
      const urlString = window.location.search;
      const urlParams = new URLSearchParams(urlString);
      const stateParam = urlParams.get('state');
      const countyParam = urlParams.get('county');
      const zipParam = urlParams.get('zip');

      function setStateWhenReady(stateCode) {
        const interval = setInterval(() => {
          const stateSelect = document.getElementById('locator-state');

          if (stateSelect && stateSelect.options.length > 1) {
            stateSelect.value = stateCode;
            stateSelect.dispatchEvent(new Event('change', { bubbles: true }));
            clearInterval(interval);
          }
        }, 100);
      }

      
      setTimeout(function() {
        var countrySelect = document.getElementById('locator-country');
        var stateSelect = document.getElementById('locator-state');
        
        if (!countrySelect || !stateSelect) return;

        if (!stateParam && (countyParam == '') && (zipParam == '')) {
          var country = "";
        } else if (!(stateParam && countyParam && zipParam)) {
          var country = "";
        } else {
          var country = "USA";
        }

        if(stateParam){
          if(usStates.includes(stateParam)) {
            var country = "USA";
          } else if(caStates.includes(stateParam)){
            var country = "Canada";
          } else {
            var country = '';
          }
        } 
        
        var options = countrySelect.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text.trim() === country) {
            countrySelect.selectedIndex = i;
            break;
          }
        }
        
        var changeEvent = new Event('change', { bubbles: true });
        countrySelect.dispatchEvent(changeEvent);
        
        setTimeout(() => {
          setStateWhenReady(stateParam);
        }, 300);
      }, 1000);
    }

    autoSelectCountry();

    // let isHome = document.body.classList.contains('frontpage');
    //
    // if (isHome) {
    //   repLocator.initStates({
    //     brand: 'RS',
    //     stateInput: document.getElementById('locator-state')
    //   });
    // }

    // Rep Locator page
    // let locatorExists = document.getElementById("locator-state");

    const unitTemplate = `<div class="info">
      <div class="left">
        <div class="contact">{{contact}}</div>
        <div class="email"><a href="mailto:{{email}}">{{email}}</a></div>
        <div class="agency">{{agency}}</div>
        <div class="address">{{address}}<br>{{city}}, {{state}} {{zip}}</div>
      </div>
      <div class="right">
        <div class="numbers">
          <div class="phone">P: <a>{{phone}}</a></div>
          <div class="fax">F: <a>{{fax}}</a></div>
        </div>
      </div>
    </div>
    <div class="notes">{{notes}}</div>`;

    const fallbackTemplate = `
      <div class="info">
        <div class="left">
          <div class="contact">Customer Service</div>
            <div class="email"><a href="mailto:customerservice@plastibond.com">customerservice@plastibond.com</a></div>
            <div class="agency">Plasti-Bond</div>
            <div class="address">1100 US Hwy 271 S<br>Gilmer, TX 75644</div>
          </div>
          <div class="right">
            <div class="numbers">
              <div class="phone">P: <a href="tel:9038435591">903.843.5591</a></div>
              <div class="fax">F: <a href="tel:9036804259">903.680.4259</a></div>
            </div>
          </div>
        </div>
      `;

    // if(settings.replocator.dataset && !isHome) {
    if (!!settings.replocator.dataset) {
      repLocator.init({
        brand: settings.replocator.dataset,
        map: document.getElementById('locator-map'),
        stateInput: document.getElementById('locator-state'),
        countyInput: document.getElementById('locator-county'),
        zipInput: document.getElementById('locator-zip'),
        resetForm: document.getElementById('form-reset'),
        resultsBox: document.getElementById('locator-results'),
        noPopulateState: true,  // render with Drupal HTML instead
        repTemplate: unitTemplate,
        fallbackTemplate: fallbackTemplate,
      });
    }
  });
  }
}
})(Drupal, once);